export const MAX_DISPLAY_PHOTOS_AMOUNT = 10
